const styles = {
  boxBG: {
    p: 3,
    bgcolor: 'rgba(1, 171, 146, 0.12)',
    borderRadius: '1.5625rem'
  },
  gradientText: {
    fontFamily: 'Outfit',
    fontWeight: 600,
    fontSize: { xs: '2rem', md: '2.5rem' },
    lineHeight: 1.25,
    background: 'linear-gradient(0deg, #FFFFFF 0%, #2983E2 200%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
    maxWidth: '100%'
  },
  greyBackground: {
    bgcolor: 'rgba(194, 194, 194, 0.12)'
  },
  divider: {
    borderColor: 'rgba(255, 255, 255, 0.1)'
  },
  dialog: {
    backgroundColor: 'rgba(26, 47, 44, 1)',
    borderRadius: '1.5625rem'
  },
  sideGrids: {
    size: {
      xs: 0,
      md: 0,
      lg: 1,
      xl: 3
    }
  },
  centralGrid: {
    size: {
      xs: 11,
      md: 11,
      lg: 10,
      xl: 6
    }
  },
  boxStyle: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    p: 3,
    bgcolor: 'rgba(1, 171, 146, 0.12)',
    borderRadius: '1.5625rem',
    flex: 'none',
    textAlign: 'center'
  },
  connectWalletBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    background: 'rgba(41, 128, 225, 0.2)',
    borderRadius: '1.5625rem',
    p: 1.5,
    gap: 1
  },
  leaderboardTitle: {
    width: '100%',
    paddingTop: '1rem',
    fontFamily: 'Outfit',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '2rem',
    lineHeight: '1.0625rem',
    color: '#FFFFFF'
  },
  leaderboardRow: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1,
    mx: 'auto',
    gap: 5,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
  },
  boxFontSize: {
    xs: '1.25rem'
  },
  greyText: {
    fontFamily: 'Outfit',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#B7B7B7'
  },
  gradientButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: { xs: '0.625rem 1.25rem', md: '0.75rem 1.5rem' },
    gap: '0.625rem',
    isolation: 'isolate',
    background: 'linear-gradient(304.25deg, #274CCC 0.76%, #2985E3 97.81%)',
    border: '0.5px solid #A3D1FF',
    borderRadius: '0.75rem',
    boxShadow: '0px 4px 50px rgba(92, 164, 248, 0.5)',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    textDecoration: 'none',

    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0px 6px 60px rgba(92, 164, 248, 0.6)'
    },

    '&:active': {
      transform: 'translateY(1px)',
      boxShadow: '0px 2px 40px rgba(92, 164, 248, 0.4)'
    },

    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
      transform: 'none'
    }
  },
  blueButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: { xs: '0.625rem 1.25rem', md: '0.75rem 1.5rem' },
    marginLeft: '3rem',
    gap: '0.625rem',
    isolation: 'isolate',
    background: 'linear-gradient(304.25deg, #274CCC 0.76%, #2985E3 97.81%)',
    borderRadius: '0.75rem',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    textDecoration: 'none',

    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0px 6px 60px rgba(92, 164, 248, 0.6)'
    },

    '&:active': {
      transform: 'translateY(1px)',
      boxShadow: '0px 2px 40px rgba(92, 164, 248, 0.4)'
    },

    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
      transform: 'none'
    }
  },
  ellipseGradient: {
    position: 'absolute',
    width: {
      xs: '100%'
    },
    height: {
      xs: '100%'
    },
    right: {
      xs: '0'
    },
    background: 'radial-gradient(50% 75.89% at 47.12% 3.38%, rgba(40, 107, 217, 0.2) 0%, rgba(40, 107, 217, 0) 100%)',
    transform: 'matrix(-1, 0, 0, 1, 0, 0)'
  }
};

export default styles;
